// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38ZQg","delete":"styles_delete__3jrbR","update":"styles_update__aMjbK","add":"styles_add__1u-N1"};